import { withTheme } from 'styled-components'
import { default as Headroom } from 'react-headroom'
import { React, Link, styled, mq } from 'x'
import { compose, pure, lifecycle, withState, withHandlers } from 'recompose'

import Menu from '../components/menu/index.js'

// import Logo from 'static/svg/logo.svg'
import Logo from 'static/svg/lp-since-2010-white.svg'
import Phone from 'static/svg/phone.svg'

import { customHeader } from './custom.css'

// #2A2D58
// flex-direction: column;
// justify-content: center;
// background: linear-gradient(-180deg, rgba(255, 255, 255, .0), rgba(255, 255, 255, .0));

const Darken = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 210px;
  width: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));

  ${mq.below('lg')} {
    display: none;
  }

  ${mq.above('lg')} {
    display: ${(props) =>
      props.theme.mode === 'light' || props.hasScrolled ? 'none' : 'block'};
  }
`

const Empty = ({ children, ...props }) => <>{children}</>

const LearningPeople = styled(Link)`
  display: inline-block;
  position: relative;
  transition: all 0.15s ease-out;

  &:hover {
    transform: scale(1.05);
  }
`

const HeaderWrapper = styled.header`
  z-index: 5;
  display: flex;

  ${(props) =>
    props.isOffersPage &&
    `
      height: 100px !important;
      position: relative !important;
      ${LearningPeople} {
        padding: 15px !important;
        & svg {
          height: 70px !important;
          margin-left: 0 !important;
        }
      }
    `}

  ${(props) =>
    props.isLandingPage &&
    `
    height: 60px !important;
    position: relative !important;
    ${LearningPeople} {
      padding: 10px 15px !important;
      & svg {
        height: 40px !important;
        margin-left: 0 !important;
      }
    }
    ${PhoneIcon} {
      background:#f5f5f3 !important;
      width:30px !important;
      height:30px !important;
      padding: 10px !important;
      text-align: center;
      vertical-align: middle;
      display: flex;
      justify-content: center;
      align-items: center;
      > svg {
        width: 22px !important;
        height: 20px !important;
      }
      @media (max-width: 480px) {
        display: none;
      }
    }
    ${PhoneNumbers} {
      & p {
        font-size: 18px !important;
        line-height: 1.4;
      }
    }
  `}

  @media (min-width: 960px) {
    /*
    position: ${(props) =>
      props.theme.mode === 'light' ? `relative` : `absolute`};
    */
    position: absolute;
    transition: background 0.37s;

    top: 0;
    left: 0;
    right: 0;
    height: 115px;
    background: ${(props) =>
      props.theme.mode === 'light' || props.hasScrolled
        ? `rgba(255, 255, 255, 1)`
        : `rgba(255, 255, 255, .0)`};

    ${LearningPeople} {
      padding: 15px 30px;
      & svg {
        transition: fill 0.37s;
        width: 80px;
        fill: ${(props) =>
          props.theme.mode === 'light' || props.hasScrolled
            ? props.theme.primaryAlt
            : `#fff`};
      }
    }
  }

  @media (min-width: 1110px) {
    ${LearningPeople} {
      padding: 30px;
      & svg {
        width: 137px;
      }
    }
  }

  @media (max-width: 960px) {
    position: fixed;
    width: 100%;
    height: 60px;

    background: ${(props) => {
      if (props.store.isMenuOpen) {
        return props.theme.primaryAlt
      } else if (props.hasScrolled) {
        return 'white'
      } else {
        return 'transparent'
      }
    }};

    transition: all 0.5s;

    ${LearningPeople} {
      padding: 12px 0px;

      & svg {
        transition: all 0.15s;
        ${'' /* margin-left: -20px; */}
        margin-left: 20px;
        height: 37px;
        fill: ${(props) =>
          props.store.isMenuOpen ? '#fff' : props.theme.primaryAlt};
      }
    }
  }
`

const RegularLink = styled.a`
  text-decoration: none;
  font-weight: 800;
`

const PhoneIcon = styled.div`
  margin-right: 20px;
  height: 40px;
  width: 40px;
  background: ${(props) => props.theme.secondary};
  padding: 20px;
  border-radius: 40px;
  @media (max-width: 480px) {
    display: none;
  }
`

const PhoneNumbers = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);

  & > div > svg {
    width: 100%;
    height: 100%;
  }

  & > p {
    display: inline-flex;
    flex-direction: column;
    margin: 0;
    font-size: 28px;
    line-height: 36px;

    & > a {
      color: ${(props) => props.theme.primaryAlt};
      font-weight: 600;
    }
  }

  ${mq.below('sm')} {
    & > p {
      font-size: 18px;
    }
  }
`

const enhance = compose(
  withState('hasScrolled', 'changeHasScrolled', false),

  withHandlers({
    updateScroll: (props) => (event) => {
      const scrollY = window.scrollY || window.pageYOffset

      if (props.store.isContactShown || props.store.isSearchShown) {
        return
      }
      if (scrollY !== 0 && props.hasScrolled === false) {
        props.changeHasScrolled(true)
      } else if (scrollY === 0 && props.hasScrolled === true) {
        props.changeHasScrolled(false)
      }
    },
  }),
  lifecycle({
    componentDidMount(...args) {
      window.addEventListener('scroll', this.props.updateScroll, false)

      this.listener = {
        event: 'menu',
        callback: () => this.forceUpdate(),
      }

      this.props.store.listeners.push(this.listener)
    },

    componentWillUnmount(...args) {
      window.removeEventListener('scroll', this.props.updateScroll, false)

      const index = this.props.store.listeners.indexOf(this.listener)

      this.props.store.listeners.splice(index, 1)
    },
  })
)

const Header = (props) => {
  const Wrapper =
    props.isOffersPage ||
    props.isLandingPage ||
    props.isBlogPage ||
    props.isBlogTopicPage ||
    (typeof window !== 'undefined' && window.innerWidth < 960)
      ? Empty
      : Headroom

  // const shouldUseHeadroom = props.isOffersPage || typeof window !== 'undefined' && window.innerWidth < 960

  return (
    <div className="gta-header">
      <Wrapper
        disabled={props.store.isContactShown || props.store.isSearchShown}
        style={{
          height: '115px',
          zIndex: 5,
        }}
        wrapperStyle={{
          height: '115px',
          zIndex: 5,
          position: props.theme.mode === 'light' ? 'relative' : 'absolute',
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        <HeaderWrapper
          store={props.store}
          hasScrolled={props.hasScrolled}
          isOffersPage={props.isOffersPage}
          isLandingPage={props.isLandingPage}
          isBlogPage={props.isBlogPage}
          isBlogTopicPage={props.isBlogTopicPage}
        >
          <Darken hasScrolled={props.hasScrolled} />
          <LearningPeople
            to={`/${props.globalData.language.prefix}/`}
            title="LearningPeople"
          >
            <Logo />
          </LearningPeople>
          {!props.isOffersPage && !props.isLandingPage ? (
            <Menu {...props} />
          ) : (
            <PhoneNumbers>
              <PhoneIcon>
                <Phone />
              </PhoneIcon>
              <p>
                <RegularLink href={props.globalData.primaryPhoneHref}>
                  {props.globalData.primaryPhoneNumber}
                </RegularLink>
                <RegularLink href={props.globalData.secondaryPhoneHref}>
                  {props.globalData.secondaryPhoneNumber}
                </RegularLink>
              </p>
            </PhoneNumbers>
          )}
        </HeaderWrapper>
      </Wrapper>
    </div>
  )
}

export default withTheme(enhance(Header))
